export class ConfirmAccountModel {
    public key: string;
    public secret: string;
}



// WEBPACK FOOTER //
// ./src/models/account/account.confirm.model.ts